module.exports = __webpack_public_path__ + "img/project13_2.jpg.bdc29659.webp";